import { render, staticRenderFns } from "./TxsList.vue?vue&type=template&id=69152874&scoped=true&"
import script from "./TxsList.vue?vue&type=script&lang=js&"
export * from "./TxsList.vue?vue&type=script&lang=js&"
import style0 from "./TxsList.vue?vue&type=style&index=0&id=69152874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69152874",
  null
  
)

export default component.exports